import React from 'react';

interface CancelButtonProps {
  onCancel: () => void;
  isRunning: boolean;
  label?: string;
}

const CancelButton: React.FC<CancelButtonProps> = ({ onCancel, isRunning, label = 'Cancel' }) => {
  if (!isRunning) return null;

  return (
    <button
      onClick={onCancel}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '8px 16px',
        background: '#ef4444',
        color: '#fff',
        border: 'none',
        borderRadius: 8,
        fontSize: 13,
        fontWeight: 600,
        cursor: 'pointer',
        animation: 'wb-pulse 2s ease-in-out infinite',
      }}
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <rect x="3" y="3" width="8" height="8" rx="1" fill="currentColor" />
      </svg>
      {label}

      <style>{`
        @keyframes wb-pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.8; }
        }
      `}</style>
    </button>
  );
};

export default CancelButton;
